<template>
  <div class="datepicker">
    <div class="input-container">
      <input type="text" @click="vToggle" v-model="dateFormate" />
      <span class="input-clear" v-if="clear" @click="vInputClear"><i class="material-icons">close</i></span>
    </div>
     <span class="input-error" v-if="activate_required">{{$_('field_required')}}</span>
    <div class="datepicker-dropdown" v-show="opened">
      <div class="datepicker-header">
        <div class="prev-month" @click="vPrevMonth">
          <span class="nav-control nav-left">
            <img src="@/common/assets/img/general/dp-arrow-left.png" />
          </span>
        </div>
        <div class="current-month">
          <span>{{currentMonthFormate}} {{currentYear}}</span>
        </div>
        <div class="next-month" @click="vNextMonth">
          <span class="nav-control nav-right">
            <img src="@/common/assets/img/general/dp-arrow-right.png" />
          </span>
        </div>
      </div>
      <div class="datepicker-calendar">
        <div class="calendar-days">
          <span v-for="(day, index) in conf.aDay" :key="index">{{day}}</span>
        </div>
        <div class="calendar-days-number">
          <div class="calendar-week" v-for="(dateItem, nIndex) in aCurrentDayMonth" :key="nIndex">
            <div 
              class="calendar-week-day"
              @click="
                disableWeekEnd === true 
                ? 
                  ((item !== undefined && item.isWeekEnd === false) && (item !== undefined && item.isDisable === false)
                    ?
                      vSelectDay(item.dayNumber) 
                    : 
                      null
                    ) 
                : 
                  ((item !== undefined) 
                    ? 
                      vSelectDay(item.dayNumber) 
                    : 
                      null
                  )"
              v-for="(item, index) in dateItem"
              :key="index"
              :class=" item !== undefined ? { active: selected === item.dayNumber
                || interval_date.first_date_selected === item.dayNumber
                || interval_date.second_date_selected === item.dayNumber
                || (item.dayNumber >= interval_date.first_date_selected && item.dayNumber <= interval_date.second_date_selected )
              } :
              
              null
              "
            >
              <div>
                <span :class="{'day-disabled':  (disableWeekEnd === true && item !== undefined && item.isWeekEnd === true) || (item !== undefined && item.isDisable === true)}">{{item !== undefined ? item.dayNumber : '' }}</span>
              </div>    
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      default: "Date",
      type: String
    },
    interval: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: true,
    },
    fromNextDay: {
      type: Boolean,
      default: false,
    },
    disableWeekEnd: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      opened: false,
      activate_required: false,
      currentMonthFormate: "",
      currentMonth: "",
      currentYear: "",
      conf: {
        aMonth: Array(
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre"
        ),
        aDay: Array("D", "L", "M", "M", "J", "V", "S")
      },
      aCurrentDayMonth: Array(),
      dateFormate: "",
      selected: -1,
      interval_date: {
        first_date: '',
        first_date_selected: {},
        second_date: '',
        second_date_selected: {},
      }
    };
  },
  created() {
    let currentDate = new Date();

    this.currentMonth = currentDate.getMonth();

    this.currentMonthFormate = this.conf.aMonth[currentDate.getMonth()];
    this.currentYear = currentDate.getFullYear();
  },
  methods: {
    vToggle() {
      this.opened = !this.opened;

      if (this.opened) {
        this.vCalculate();
      }
    },
    vNextMonth() {
      this.currentMonth++;
      this.selected = -1;

      if (this.currentMonth > 11) {
        this.currentMonth = 0;
        this.currentYear++;
      }

      this.currentMonthFormate = this.conf.aMonth[this.currentMonth];
      this.vCalculate();
    },
    vPrevMonth() {
      this.currentMonth--;
      this.selected = -1;

      if (this.currentMonth < 0) {
        this.currentMonth = 11;
        this.currentYear--;
      }

      this.currentMonthFormate = this.conf.aMonth[this.currentMonth];
      this.vCalculate();
    },
    vCalculate() {
      this.aCurrentDayMonth = Array();

      let currentDate = new Date();

      let date = new Date(this.currentYear, this.currentMonth + 1, 0);
      let aWeek = Array();

      for (var i = 1; i <= date.getDate(); i++) {
        let dateTime = new Date(this.currentYear, this.currentMonth, i);

        if (dateTime.getDay() !== 0) {

          // if(dateTime < currentDate) {
          //   aWeek[dateTime.getDay()] = {dayNumber: dateTime.getDate(), isWeekEnd: false, isDisable: true };
          // } else {
            // aWeek[dateTime.getDay()] = {dayNumber: dateTime.getDate(), isWeekEnd: dateTime.getDay() === 0 || dateTime.getDay() === 6 ? true : false };
          // }

          aWeek[dateTime.getDay()] = {
            dayNumber: dateTime.getDate(), 
            isWeekEnd: dateTime.getDay() === 0 || dateTime.getDay() === 6 ? true : false,
            isDisable: (this.$props.fromNextDay === true && dateTime < currentDate) ? true : false
          };

        } else if (dateTime.getDay() === 0) {
          this.aCurrentDayMonth.push(aWeek);
          aWeek = Array();

          // if(dateTime < currentDate) {
          //   aWeek[dateTime.getDay()] = {dayNumber: dateTime.getDate(), isWeekEnd: false, isDisable: true };
          // } else {
            aWeek[dateTime.getDay()] = {
              dayNumber: dateTime.getDate(), 
              isWeekEnd: dateTime.getDay() === 0 || dateTime.getDay() === 6 ? true : false,
              isDisable:  (this.$props.fromNextDay === true && dateTime < currentDate) ? true : false
            };
          // }
        }

        if (i === date.getDate()) {
          this.aCurrentDayMonth.push(aWeek);
        }
      }
    },
    vSelectDay(dateItem) {

      let date = new Date(this.currentYear, this.currentMonth, dateItem);
      
      if(this.$props.interval) {

        if(this.interval_date.first_date !== '' && this.interval_date.second_date !== '') {
          this.interval_date.first_date = '';
          this.interval_date.first_date_selected = {};
          this.interval_date.second_date = '';
          this.interval_date.second_date_selected = {};
        }

        if(this.interval_date.first_date === '') {
          this.interval_date.first_date = date.toLocaleDateString("fr-FR");
          this.interval_date.first_date_selected = dateItem;
        } else if (this.interval_date.second_date === '') {
          this.interval_date.second_date = date.toLocaleDateString("fr-FR");
          this.interval_date.second_date_selected = dateItem;
        }

        this.dateFormate = this.interval_date.first_date + ' - ' + this.interval_date.second_date;

        if(this.interval_date.first_date !== '' && this.interval_date.second_date !== '') {
          this.$emit("datepicker:select", this.dateFormate);
          this.opened = false;
        }
        
      } else {

        if (this.selected == dateItem) {
          this.selected = -1;
          this.dateFormate = "";
        } else {
          this.dateFormate = date.toLocaleDateString("fr-FR");
          this.selected = dateItem;
        }
        this.$emit("datepicker:select", this.dateFormate);
        this.opened = false;
      }
      

    },
    vInputClear() {
      this.dateFormate = '';
      this.selected = {};
      this.interval_date.first_date = '';
      this.interval_date.first_date_selected = {};
      this.interval_datesecond_date = '';
      this.interval_date.second_date_selected = {};
      this.$emit("datepicker:select", '');
      
    }
  }
};
</script>

<style scoped>
.datepicker {
  width: 200px;
}
.datepicker input[type="text"] {
  width: 100%;
}
.datepicker-header {
  display: flex;
  padding: 10px 10px;
  border-bottom: solid 1px #e9e9e9;
  margin-bottom: 10px;
  align-items: center;
}
.calendar-week {
  display: flex;
}
.current-month {
  color: #bfbfbf;
}
.datepicker-dropdown {
  width: 225px;
  border: solid 1px #e9e9e9;
  font-size: var(--fz-md);
  position: absolute;
  background-color: #fff;
  margin-top: 10px;
  z-index: 110;
}
.calendar-days {
  display: flex;
  margin-bottom: 10px;
}
.calendar-days span,
.calendar-week-day {
  width: calc(100% / 7);
  text-align: center;
  font-size: var(--fz-md);
}
.calendar-week-day {
  transition: all 0.3s;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-week-day.active {
  background-color: #b5e664;
}
.calendar-week-day.active span {
  color: #fff;
}
.calendar-week-day:hover {
  background-color: #b5e664;
  cursor: pointer;
}
.calendar-week-day span {
  color: #2a2a2a;
}
.calendar-week-day:hover span {
  color: #fff;
}
.prev-month,
.next-month {
  flex: 1;
}
.next-month {
  text-align: right;
}
.nav-control img {
  width: 9px;
}
.input-container {
  display: flex;
  align-items: center;
  position: relative;
  flex-direction: column;
  text-align: left;
}
.input-clear {
  position: absolute;
  right: 10px;
  background-color: #cacaca;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 50%;
  transition: all .3s;
  top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.input-clear:hover {
  cursor: pointer;
  background-color: #989898;
}
.input-clear i {
  font-size: 1rem;
  color: #fff;
}
.day-disabled {
  color: lightgray !important;
}
</style>